import { es } from 'date-fns/locale';
import { useTranslation } from 'next-i18next';
import React, { useContext, useEffect, useLayoutEffect } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';

import { WorkingDayReconciliationContext } from '@/modules/workingDayReconciliation/context/context';
import { workingDayReconciliationActionsTypes as ActionsTypes } from '@/modules/workingDayReconciliation/context/reducer';
import { Typography } from '@/shared/components/atoms';
import { getDateFormat } from '@/shared/components/molecules/CustomDatePicker/logic';

import Calender from '~/images/shared/calender.svg';
registerLocale('es', es);
// TODO: refactor this mad file!!!
const RangeDatePicker = () => {
  const {
    state: { endDate, startDate },
    dispatch,
  } = useContext(WorkingDayReconciliationContext);
  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const today = new Date();

  useLayoutEffect(() => {
    const initStartDate = sessionStorage.getItem(
      'workingDayReconciliationStartDate'
    );
    const initEndDate = sessionStorage.getItem(
      'workingDayReconciliationEndDate'
    );
    if (initStartDate) {
      dispatch({
        type: ActionsTypes.setStartDate,
        payload: new Date(initStartDate),
      });
    } else {
      const tempSD = new Date();
      tempSD.setDate(tempSD.getDate() - 7);
      dispatch({
        type: ActionsTypes.setStartDate,
        payload: new Date(tempSD),
      });
      sessionStorage.setItem(
        'workingDayReconciliationStartDate',
        new Date(tempSD).toString()
      );
    }

    if (initEndDate) {
      dispatch({
        type: ActionsTypes.setEndDate,
        payload: new Date(initEndDate),
      });
    } else {
      const tempED = new Date();
      tempED.setDate(tempED.getDate());
      dispatch({ type: ActionsTypes.setEndDate, payload: new Date(tempED) });
      sessionStorage.setItem(
        'workingDayReconciliationEndDate',
        new Date(tempED).toString()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (startDate) {
      sessionStorage.setItem(
        'workingDayReconciliationStartDate',
        startDate.toString()
      );
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
      sessionStorage.setItem(
        'workingDayReconciliationEndDate',
        endDate.toString()
      );
    }
  }, [endDate]);

  return (
    <div className='flex items-center gap-1 rounded-xl bg-outline-default py-9 px-16 text-text-default'>
      <div className='text-20 text-primary-default'>
        <Calender />
      </div>
      {startDate && (
        <DatePicker
          wrapperClassName='relative'
          locale={language}
          selected={startDate}
          maxDate={endDate}
          onChange={(date) =>
            date
              ? dispatch({ type: ActionsTypes.setStartDate, payload: date })
              : null
          }
          customInput={
            <Typography
              variant='body1'
              weight='bold'
              className='w-fit cursor-pointer whitespace-nowrap'
            >
              {getDateFormat(startDate, language, 'dd MMM, YYY')}
            </Typography>
          }
        />
      )}
      <span className='text-16'>{t('to')}</span>
      {endDate && (
        <DatePicker
          wrapperClassName='relative'
          locale={language}
          selected={endDate}
          maxDate={today}
          minDate={startDate}
          onChange={(date) =>
            date
              ? dispatch({ type: ActionsTypes.setEndDate, payload: date })
              : null
          }
          customInput={
            <Typography
              variant='body1'
              weight='bold'
              className='w-fit cursor-pointer whitespace-nowrap'
            >
              {getDateFormat(endDate, language, 'dd MMM, YYY')}
            </Typography>
          }
        />
      )}
    </div>
  );
};
export { RangeDatePicker };
